import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import TheatreSidebar from "../Layouts/TheatreSidebar";

import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";

export class OImmediateObservationOfTheMother extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      bp: "",
      temp: "",
      pulse: "",
      hemorrhage: "",
      uterinecontraction: "",
      visitid: localStorage.getItem("currentVisitId"),
      loading: false

    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  componentDidMount() {
    $(".obstudydone").on("click", function () {
      $(".obSoundDone").show();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    var visitid = $(".visitid").text();
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("visitId"),
      surgeryid: localStorage.getItem("surgeryid"),
    };

    event.preventDefault();

    //    console.log(visitid)

    var dict = {
      bp: JSON.stringify(this.state.tablevaluesglobal[0]),
      temp: JSON.stringify(this.state.tablevaluesglobal[1]),
      pulse: JSON.stringify(this.state.tablevaluesglobal[2]),
      hemorrhage: JSON.stringify(this.state.tablevaluesglobal[3]),
      uterinecontraction: JSON.stringify(this.state.tablevaluesglobal[4]),
    };
    console.log(dict);
    this.setState({
      loading: true
    })
    axios
      .post(this.api_url+"delivery/observationmother", dict, {
        headers: headers,
      })
      .then((response) => {
        this.setState({
          loading: false
        })
        console.log(response);
        
        if (response.data["status"]) {
          $(".alert-success").show();
          window.location.href = "/theatre/post/operative/orders"

        }
      })
      .catch((error) => {
        console.log(error);
         this.setState({
          loading: false
        })
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  handleTableChange(event) {
    console.log(event);
    this.setState({ myParentTrigger: this.state.myParentTrigger + "a" });
  }

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    console.log(data);
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};

      trimobj.followUp = data[i][0];
      trimobj.firstHour = data[i][1];
      trimobj.secondHour = data[i][2];
      trimobj.observation = data[i][3];

      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }

  getTableValues(event) {
    console.log("entns");
    console.log(event);
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    const data = [
      ["BP", "", "", ""],
      ["T°", "", "", ""],
      ["Hemorrhage ˂500ml/ ˃500ml  ", "", "", ""],
      ["Pulse ", "", "", ""],
      ["Uterine contraction", "", "", ""],
    ];
    const columns = [
      "Follow-up",
      "1st hour",
      "2nd hour",
      "Observations/treatment",
    ];
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { bp, temp, pulse, hemorrhage, uterinecontraction, loading } = this.state;

    // {""1st":{"date""12/12/2022", "result":"good"}, "2nd":{"date":12/12/2022"","result":"good"}}

    return (
      <div>
        <Headers />
        <TheatreSidebar />

        <main>
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Immediate Observation Of The Mother
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="#editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
                  <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>
              <div className="row">

             
                <br />
                <br />
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading ? 'Loading' :'Submit'} 
                  </button>
                </div>
              
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default OImmediateObservationOfTheMother;
